// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/pie
// import { ResponsivePie } from '@nivo/pie';
import { ResponsivePie } from '@nivo/pie';

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const PieAge = ({ data /* see data tab */ }: any) => (
  <ResponsivePie
    data={data}
    margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
    // radialLabelsTextColor={data}
    // innerRadius={0.5}
    // padAngle={0.7}
    // cornerRadius={3}
    // activeOuterRadiusOffset={8}
    // borderWidth={1}
    // borderColor={{
    //   from: 'color',
    //   modifiers: [['darker', 0.2]]
    // }}
    // arcLinkLabelsSkipAngle={10}
    // arcLinkLabelsTextColor="#333333"
    // arcLinkLabelsThickness={2}
    // arcLinkLabelsColor={{ from: 'color' }}
    // arcLabelsSkipAngle={10}
    // arcLabelsTextColor={{
    //   from: 'color',
    //   modifiers: [['darker', 2]]
    // }}
    //아래 테이블

    legends={[
      {
        anchor: 'bottom',
        direction: 'row',

        // justify: false,
        // translateX: 0,
        translateY: 56,
        // itemsSpacing: 0,
        itemWidth: 100,
        itemHeight: 18,
        // itemTextColor: '#999',
        // itemDirection: 'left-to-right',
        // itemOpacity: 1,
        // symbolSize: 18,
        // symbolShape: 'circle',
        effects: [
          {
            on: 'hover',
            style: {
              itemTextColor: '#000'
            }
          }
        ]
      }
    ]}
  />
);
export default PieAge;
